<template>
  <div>
    <van-row style="height: 38px; line-height: 35px; background: #000000">
      <van-col
        span="2"
        style="line-height: 35px"
        onclick="window.history.go(-1)"
      >
        <van-icon
          name="arrow-left"
          style="padding-top: 5px"
          color="#ffffff"
          size="27px"
        />
      </van-col>

      <van-col span="6">
        <van-row class="btnBorder">
          <van-col
            span="12"
            v-bind:class="[buySellTab === 'buy' ? 'activeBtn' : '']"
            style="border-radius: 2px 0px 0px 2px"
            @click="buySellTab = 'buy'"
            ><span class="btnText">买入</span></van-col
          >
          <van-col
            span="12"
            v-bind:class="[buySellTab === 'sell' ? 'activeBtn' : '']"
            style="border-radius: 0px 2px 2px 0px"
            @click="buySellTab = 'sell'"
            ><span class="btnText">卖出</span></van-col
          >
        </van-row>
      </van-col>
      <van-col span="14" id="capitalAccountStyle">
        <div>
          <van-field
            readonly
            clickable
            :value="selectedAccount.name + '(' + selectedAccount.order + ')'"
            @click="showPicker = true"
            style="
              height: 30px;
              background: #000000;
              color: #ffffff;
              line-height: 30px;
              margin-top: 4px;
              padding: 0;
              text-align: right;
            "
          />
        </div>
      </van-col>
      <van-col span="2" style="padding-right: 10px">
        <van-icon
          name="arrow-down"
          style="padding-top: 11px"
          color="#ffffff"
          size="17px"
        />
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="capitalAccountsPickerList"
        @cancel="showPicker = false"
        @confirm="onAccountSelect"
        style="font-size: 14px"
      />
    </van-popup>
    <div class="mainSection">
      <div class="tradingSection">
        <van-row class="shareDesign">
          <van-col span="6" style="text-align: left">
            <span class="shareName">{{ topData.name }}</span>
          </van-col>
          <van-col span="6">
            <span class="shareCode">{{
              selectedShare.slice(2) ? selectedShare.slice(2) : "--"
            }}</span>
          </van-col>
          <van-col span="6">
            <span
              class="currentPrice"
              v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
              >{{ updown }}</span
            >
          </van-col>
          <van-col span="6" style="text-align: right">
            <span
              class="increasePrecent"
              v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
              >{{ topData.increasePercent }}%</span
            >
          </van-col>
        </van-row>

        <van-row style="padding-top: 10px">
          <!-- ======================== serach stock ================ -->
          <van-col span="14">
            <van-row style="border: 1px solid #387fff">
              <van-col span="20">
                <div id="searchStyle">
                  <van-field
                    v-model="search"
                    placeholder=""
                    style="
                      padding: 0px 10px;
                      line-height: 30px;
                      height: 32px;
                      background-color: #000000;
                      color: #ffffff;
                    "
                  /></div
              ></van-col>
              <van-col span="4" style="border-left: 1px solid #387fff">
                <div>
                  <!-- <router-link > to="/trading_search_stock" -->
                  <van-icon
                    name="search"
                    size="27px"
                    color="#ffffff"
                    @click="$router.push({ name: 'TradingSearchStock' })"
                  />
                  <!-- </router-link> -->
                </div>
              </van-col>
            </van-row>
            <!-- ====================== start set price ============== -->
            <van-row style="padding-top: 10px">
              <van-col span="5">
                <van-button type="info" size="small" @click="onMarketPrice">{{
                  priceButtonLabel
                }}</van-button>
              </van-col>
              <van-col span="4" class="minusSignCol">
                <van-button
                  type="info"
                  class="minusSign"
                  @click="onPriceControlButton('down')"
                  >-</van-button
                >
              </van-col>
              <van-col span="11" class="limitValue">
                <div id="searchStyle">
                  <van-field
                    v-model="price"
                    style="
                      padding: 0px 10px;
                      line-height: 30px;
                      height: 30px;
                      background-color: #000000;
                      color: #ffffff;
                    "
                    :readonly="priceButtonLabel === marketPriceLabel"
                  />
                </div>
              </van-col>
              <van-col span="4" class="plusSignCol">
                <van-button
                  type="info"
                  class="plusSign"
                  @click="onPriceControlButton('up')"
                  >+</van-button
                >
              </van-col>
            </van-row>

            <!-- ============================= start max and min value ================== -->

            <van-row style="padding-top: 5px">
              <van-col span="11" style="text-align: left">
                <div class="lossAmt" @click="setLimitPrice(topData.dropPrice)">
                  跌停:
                  <span style="color: #8bc34a">{{ topData.dropPrice }}</span>
                </div>
              </van-col>
              <van-col span="2"></van-col>
              <van-col span="11" style="text-align: right">
                <div style="padding: 1px; float: right">
                  <div
                    class="lossAmt"
                    @click="setLimitPrice(topData.hardenPrice)"
                  >
                    涨停:
                    <span style="color: #ff2c27">{{
                      topData.hardenPrice
                    }}</span>
                  </div>
                </div>
              </van-col>
            </van-row>

            <!-- ======================== start number of stocks ============================ -->

            <van-row style="padding-top: 10px">
              <van-col span="4" class="minusSignCol">
                <van-button
                  type="info"
                  class="minusSign"
                  @click="onAmountControlButton('down')"
                  >-</van-button
                >
              </van-col>
              <van-col span="16" class="limitValue">
                <div id="searchStyle">
                  <van-field
                    v-model="quantity"
                    style="
                      padding: 0px 10px;
                      line-height: 30px;
                      height: 30px;
                      background-color: #000000;
                      color: #ffffff;
                    "
                  />
                </div>
              </van-col>
              <van-col span="4" class="plusSignCol">
                <van-button
                  type="info"
                  class="plusSign"
                  @click="onAmountControlButton('up')"
                  >+</van-button
                >
              </van-col>
            </van-row>

            <!-- ===========================  start total number of shares =================== -->

            <van-row style="padding-top: 2px">
              <van-col span="24" style="text-align: left; font-size: 14px">
                <span style="line-height: 30px; color: #ffffff">
                  {{ buySellTab === "buy" ? "可买股数" : "可卖股数" }} :</span
                ><span style="color: #ffffff">{{ getBuyableAmount }}</span>
              </van-col>
            </van-row>

            <!-- ======================= start quick quantity select ======================== -->

            <van-row style="padding-top: 10px">
              <van-col span="8" style="padding-right: 5px">
                <van-button
                  type="danger"
                  size="small"
                  class="warehouse"
                  v-bind:class="quntityBtn==1?'tradingQtyStyle':''"
                  @click="setTradingQty(1)"
                  >全仓</van-button
                >
              </van-col>
              <van-col span="8" style="padding-right: 2px; padding-left: 2px">
                <van-button
                  type="danger"
                  size="small"
                  class="warehouse"
                  v-bind:class="quntityBtn==0.5?'tradingQtyStyle':''"
                  @click="setTradingQty(0.5)"
                  >半仓</van-button
                >
              </van-col>
              <van-col span="8" style="padding-left: 5px">
                <van-button
                  type="danger"
                  size="small"
                  class="warehouse"
                  v-bind:class="quntityBtn==1/3?'tradingQtyStyle':''"
                  @click="setTradingQty(1/3)"
                  >1/3仓</van-button
                >
              </van-col>
            </van-row>

            <!-- ======================== buy and sell button===================== -->

            <van-row style="padding-top: 10px">
              <van-col span="2"> </van-col>
              <van-col span="20">
                <van-button
                  type="danger"
                  size="large"
                  style="height: 30px"
                  v-if="buySellTab === 'buy'"
                  @click="buySellOperation"
                  >买入</van-button
                >
                <van-button
                  type="primary"
                  size="large"
                  style="height: 30px"
                  v-if="buySellTab === 'sell'"
                  @click="buySellOperation"
                  >卖出</van-button
                >
              </van-col>
              <van-col span="2"> </van-col>
            </van-row>
          </van-col>
          <!-- ==================== Start Right panel with 5 list price================================ -->
          <van-col span="10">
            <!-- <van-row>
              <van-col span="24" style="text-align:center"> <span>五格行情</span> </van-col>
            </van-row> -->
            <van-row>
              <van-col span="24" style="height: 14px"> </van-col>
            </van-row>
            <!-- ====================== sell 5 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">卖5</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.sell5Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell5Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== sell 4 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">卖4</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.sell4Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell4Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== sell 3 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">卖3</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.sell3Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell3Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== sell 2 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">卖2</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.sell2Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell2Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== sell 1 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">卖1</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.sell1Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.sell1Num }}</span>
              </van-col>
            </van-row>

            <van-row style="padding: 10px 5px">
              <van-col span="24" style="border: 1px solid #969799"></van-col>
            </van-row>

            <!-- ====================== buy 1 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">买1</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.buy1Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy1Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== buy 2 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">买2</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.buy2Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy2Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== buy 3 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">买3</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.buy3Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy3Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== buy 2 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">买4</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.buy4Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy4Num }}</span>
              </van-col>
            </van-row>
            <!-- ====================== buy 1 =================== -->
            <van-row>
              <van-col span="8">
                <span class="capital">买5</span>
              </van-col>
              <van-col span="8">
                <span class="capital" style="color: #ff2c27">{{
                  topData.buy5Price
                }}</span>
              </van-col>
              <van-col span="8">
                <span class="capital">{{ topData.buy5Num }}</span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>

    <!-- ====================== Below table details =================== -->

    <van-tabs
      v-model="active"
      id="detailTable"
      background="#c8c9cc"
      @click="onTabClick"
    >
      <!-- ====================== Tab 1 =================== -->
      <van-tab title="持仓" name="depot">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">名称代码</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">持仓/可用</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">现价/成本</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">浮动盈亏</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">持仓市值</span>
          </van-col>
        </van-row>

        <van-row
          v-for="(item, index) in depotList"
          :key="index"
          style="height: 40px"
          @click="onDepotItem(item)"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.name }}</p>
              <p>{{ item.code }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.number }}</p>
              <p>{{ item.sellable }}</p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>
                {{
                  bottomStockList.find((o) => o.short === item.short).price
                }}
              </p>
              <p>{{ item.price }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: #0adc0aad">
              <p
                v-bind:class="[
                  getFloatingProfitPercentage(item) >= 0
                    ? 'redText'
                    : 'greenText',
                ]"
              >
                {{ getFloatingProfitPercentage(item) }}%
              </p>
              <p
                v-bind:class="[
                  getFloatingProfitPercentage(item) >= 0
                    ? 'redText'
                    : 'greenText',
                ]"
              >
                {{ getFloatingFullProfit(item) }}
              </p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ getCurrentTotal(item) }}</p>
            </div>
          </van-col>
        </van-row>
      </van-tab>
      <!-- ====================== Tab 2 =================== -->
      <van-tab title="撤单" name="cancel">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">名称代码</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">委托/状态</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">委托/成交</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">持仓/可卖</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">委托时间</span>
          </van-col>
        </van-row>

        <van-row
          v-for="(item, index) in cancelList"
          :key="index"
          style="height: 40px"
          @click="cancelEntrustConfirm(item)"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.name }}</p>
              <p>{{ item.code }}</p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>{{ item.type }}</p>
              <p>{{ item.status }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.deal }}</p>
              <p>{{ item.price !== "0.00" ? item.price : "--" }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.number }}</p>
              <p>{{ item.finish }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.time }}</p>
              <p>{{ item.accurate }}</p>
            </div>
          </van-col>
        </van-row>
      </van-tab>
      <!-- ====================== Tab 3 =================== -->
      <van-tab title="委托" name="entrust">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">名称代码</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">委托/状态</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">委托/成交</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">持仓/可卖</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">委托时间</span>
          </van-col>
        </van-row>
        <van-row
          v-for="(item, index) in entrustLogList"
          :key="index"
          style="height: 40px"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.name }}</p>
              <p>{{ item.code }}</p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>{{ item.type }}</p>
              <p>{{ item.status }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.deal != 0 ? item.deal : "--" }}</p>
              <p>{{ item.price != 0 ? item.price : "--" }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.number }}</p>
              <p>{{ item.finish }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.time }}</p>
              <p>{{ item.accurate }}</p>
            </div>
          </van-col>
        </van-row>
      </van-tab>
      <!-- ====================== Tab 4 =================== -->
      <van-tab title="成交" name="deal">
        <van-row style="padding-bottom: 10px">
          <van-col span="5" style="text-align: center">
            <span class="text_style">名称代码</span>
          </van-col>
          <van-col span="4" style="text-align: center">
            <span class="text_style">买卖/数量</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">价格/总额</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">手续费</span>
          </van-col>
          <van-col span="5" style="text-align: center">
            <span class="text_style">委托时间</span>
          </van-col>
        </van-row>
        <van-row
          v-for="(item, index) in dealLogList"
          :key="index"
          style="height: 40px"
          @click="showPopup(item.id)"
        >
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.name }}</p>
              <p>{{ item.code }}</p>
            </div>
          </van-col>
          <van-col span="4">
            <div class="capital" style="color: black">
              <p>{{ item.type }}</p>
              <p>{{ item.number }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.price }}</p>
              <p>{{ item.total }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.fee }}</p>
            </div>
          </van-col>
          <van-col span="5">
            <div class="capital" style="color: black">
              <p>{{ item.time }}</p>
              <p>{{ item.accurate }}</p>
            </div>
          </van-col>
        </van-row>
        <!-- ============================================ Deal POPup =========================================== -->
        <van-popup v-model="showDealPopup" round style="width: 90%">
          <table style="width: 100%; padding: 20px">
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>日期时间</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.time }} {{ dealData.accurate }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>业务名称</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.type }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>股票代码</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.name }} {{ dealData.code }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>成交数量</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.number }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>成交价格</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.price }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>成交金额</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.total }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>券商佣金</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.commission }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>过户费</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.change }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>印花税</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.stamp }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>产品处理费</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.extra_fee1 }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>结算费用</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.extra_fee2 }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>平台费用</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.extra_fee3 }}</span>
              </td>
            </tr>
            <tr class="dealPopupRow">
              <td style="width: 50%">
                <span>总金额</span>
              </td>
              <td style="width: 50%; text-align: right">
                <span>{{ dealData.totalplus }}</span>
              </td>
            </tr>
          </table>
          <van-row style="padding: 10px">
            <van-col span="2"></van-col>
            <van-col span="20">
              <van-button
                type="danger"
                size="normal"
                style="width: 100%; height: 34px"
                @click="closePopup()"
                >取消</van-button
              >
            </van-col>
            <van-col span="2"></van-col>
          </van-row>
        </van-popup>
      </van-tab>
    </van-tabs>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import CommonLoading from "./CommonLoading";
export default {
  name: "Trading",
  components: {
    CommonLoading,
  },
  data() {
    return {
      buySellTab: "buy",
      active: "depot",
      search: "",
      price: 0,
      quantity: 0,
      sellableQty: 0,
      selectedShare: "",
      timerRef: null,
      topData: {
        name: "--",
        increase: "--",
        price: "--",
        increasePercent: "--",
        dropPrice: "--",
        hardenPrice: "--",
        sell5Price: "--",
        sell4Price: "--",
        sell3Price: "--",
        sell2Price: "--",
        sell1Price: "--",
        sell5Num: "--",
        sell4Num: "--",
        sell3Num: "--",
        sell2Num: "--",
        sell1Num: "--",
        buy1Price: "--",
        buy2Price: "--",
        buy3Price: "--",
        buy4Price: "--",
        buy5Price: "--",
        buy1Num: "--",
        buy2Num: "--",
        buy3Num: "--",
        buy4Num: "--",
        buy5Num: "--",
      },
      selectedAccount: { name: "--", order: "--" },
      marketPriceBuyLabel: "市价买入",
      marketPriceSellLabel: "市价卖出",
      limitPriceLabel: "限价",
      marketPriceLabel: "市价",
      priceButtonLabel: "",
      capitalAccountList: [],
      showPicker: false,
      capitalAccountsPickerList: [],
      depotList: [],
      cancelList: [],
      entrustLogList: [],
      dealLogList: [],
      dealData: {},
      bottomStockList: [],
      timmerFrequncy: 2000,
      timmerRef: null,
      showDealPopup: false,
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      quntityBtn: null,
    };
  },
  watch: {
    quantity: function (val) {
      if (val < 0) {
        this.quantity = 0;
        return;
      }
    },
    price: function (val) {
      if (this.priceButtonLabel === this.limitPriceLabel) {
        this.buyableAmountCalculation();
      }
    },
    search: function (val) {
      if (val.length == 6) {
        //this.selectedShare = val;
        //this.loadMarketData();
        this.query_stocks(val);
      }
    },
    buySellTab: function () {
      if (this.priceButtonLabel === this.marketPriceLabel) {
        this.price =
          this.buySellTab === "buy"
            ? this.marketPriceBuyLabel
            : this.marketPriceSellLabel;
      }
      //set qty input 0 when tab is changed
      this.quantity = 0;
      this.quntityBtn = null;
    },
  },
  computed: {
    getBuyableAmount() {
      if (this.buySellTab === "buy") {
        return this.buyableAmountCalculation();
      } else {
        //when showing sell tab, check selected share depot in the list
        //and show sellabel qty
        if (this.selectedShare) {
          let shareItem = this.depotList.find(
            (o) => o.short === this.selectedShare
          );
          if (shareItem) {
            this.sellableQty = shareItem.sellable;
          } else {
            this.sellableQty = 0;
          }
        }
        return this.sellableQty;
      }
    },
    updown() {
      let val = (this.topData.price - this.topData.yesterdayClosePrice).toFixed(
        2
      );
      return isNaN(val) ? "--" : val;
    },
  },
  methods: {
    query_stocks(query) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "get_stocks",
            words: query,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length >= 1) {
              that.selectedShare = res.data.data[0].short;
              that.loadMarketData(true);
            }
          } else if (res.data.code === 0) {
            that.$toast.fail(res.data.msg);
          } else if (res.data.code === -1) {
            that.$logout(res.data.msg);
          }
        });
    },
    cancelEntrustConfirm(item) {
      let that = this;
      Dialog.confirm({
        title: "撤单",
        message: "您将要撤销该股票，是否继续？",
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          that.cancelEntrust(item);
        })
        .catch(() => {});
    },
    cancelEntrust(item) {
      let that = this;
      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "cancel_entrust",
          token: sessionStorage.getItem("token"),
          cid: that.selectedAccount.cid,
          order: item.id,
        },
      })
        .then(function (res) {
          if (res.data.code == 1) {
            Toast.success(res.data.msg);
            that.onTabClick();
          } else if (res.data.code == 0) {
            Toast.fail(res.data.msg);
          }
        })
        .catch(function () {
          Toast.fail();
        });
    },
    onTabClick() {
      switch (this.active) {
        case "depot":
          this.active = "depot";
          this.getDepotStock();
          break;
        case "cancel":
          this.geCancelOrders();
          break;
        case "entrust":
          this.getEntrustLog();
          break;
        case "deal":
          this.getDealLog();
          break;
        default:
          break;
      }
    },
    getDepotStock() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.depotList = [];
          if (res.data.code == 1) {
            that.depotList = res.data.data;
            that.loadMarketData();
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    geCancelOrders() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_order",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.cancelList = [];
          if (res.data.code == 1) {
            that.cancelList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getEntrustLog() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "entrust_log",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.entrustLogList = [];
          if (res.data.code == 1) {
            that.entrustLogList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getDealLog() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "deal_log",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.dealLogList = [];
          if (res.data.code == 1) {
            that.dealLogList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    showPopup(dealId) {
      // this.showDealPopup = true;
      let that = this;
      // Toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_deal",
            token: sessionStorage.getItem("token"),
            deal_id: dealId,
          },
        })
        .then(function (res) {
          // Toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            that.dealData = res.data.data[0];
            that.showDealPopup = true;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    closePopup() {
      this.showDealPopup = false;
    },
    setTradingQty(ratio) {
      if (this.buySellTab === "buy") {
        let qty = parseFloat(this.buyableAmountCalculation() * ratio).toFixed(
          0
        );
        qty = parseInt(qty / 100) * 100;
        this.quantity = qty < 0 ? 0 : qty;
      } else {
        let qty = parseFloat(this.sellableQty * ratio).toFixed(0);
        qty = parseInt(qty / 100) * 100;
        this.quantity = qty < 0 ? 0 : qty;
      }
      this.quntityBtn = ratio;
    },
    buyableAmountCalculation() {
      if (this.selectedAccount == null || this.selectedShare === "") return 0;
      let use = parseFloat(this.selectedAccount.use);
      let price =
        this.priceButtonLabel === this.marketPriceLabel
          ? parseFloat(this.topData.price)
          : this.price;
      let qty = use / price;
      qty = Math.floor(qty);
      return isNaN(qty) ? "--" : qty;
    },
    onAmountControlButton(direction) {
      if (direction === "up") {
        this.quantity = parseInt(this.quantity) + 100;
      }
      if (direction === "down") {
        this.quantity = parseInt(this.quantity) - 100;
      }
    },
    /**
     * method to controll price +,- buttons
     * 1. check if limit price set, if not change to limit price
     * 2. if direction up, increase price by 0.05
     * 3. if direction down, decriment price by 0.05
     */
    onPriceControlButton(direction) {
      if (this.priceButtonLabel !== this.limitPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
        this.price = this.topData.price;
        return;
      }
      if (direction === "up") {
        this.price = parseFloat(this.price) + 0.01;
      }
      if (direction === "down") {
        this.price = parseFloat(this.price) - 0.01;
      }

      this.price = parseFloat(this.price).toFixed(2);
    },
    setLimitPrice(price) {
      if (this.priceButtonLabel !== this.limitPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
      }
      this.price = price;
    },
    onMarketPrice() {
      if (this.priceButtonLabel === this.marketPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
        this.price = this.topData.price;
      } else {
        this.priceButtonLabel = this.marketPriceLabel;
        this.price =
          this.buySellTab === "buy"
            ? this.marketPriceBuyLabel
            : this.marketPriceSellLabel;
      }
    },
    /**
     * load capital account info
     * 1.get capital data
     * 2.set first account as selected account
     * 3.load depot stock
     */
    getCapitalAccounts() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.capitalAccountList = res.data.data;
            if (that.capitalAccountList.length == 0) {
              Dialog.confirm({
                message: "还没有有配资合约，请先完成配资",
                cancelButtonText: "取消",
                confirmButtonText: "前去配置配资",
              })
                .then(() => {
                  that.$router.push({ name: "CreateCapitalAccounts" });
                })
                .catch(() => {
                  that.$router.go(-1);
                });
            } else {
              if (that.$store.state.selectedCid) {
                that.selectedAccount = that.capitalAccountList.find(
                  (o) => o.cid == that.$store.state.selectedCid
                );
              } else {
                that.selectedAccount = that.capitalAccountList[0];
              }
              //generate list for picker
              that.capitalAccountsPickerList = [];
              that.capitalAccountList.forEach(function (element, index) {
                let item = {
                  text:
                    element.name +
                    "(" +
                    element.order +
                    ") 余额:" +
                    element.use,
                  value: index,
                };
                that.capitalAccountsPickerList.push(item);
              });
              that.getDepotStock();
            }
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          } else if (res.data.code == -1) {
            that.$logout(res.data.msg);
          }
        });
    },
    /**
     * load market data from datasource
     * 1.get all market data from datasource
     * 2.set top data part
     * 3.set bottom data parts
     */
    loadMarketData(changeInputPrice = false) {
      let that = this;

      let stockList = [];
      that.depotList.forEach((item) => {
        stockList.push(item.short);
      });

      let url =
        "https://sqt.gtimg.cn/utf8/q=" +
        that.selectedShare +
        "," +
        stockList.toString();
      $.ajax({
        url: url,
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          if (that.selectedShare) {
            that.topData = that.getStockObject(that.selectedShare);
            if (
              changeInputPrice &&
              that.priceButtonLabel === that.limitPriceLabel
            ) {
              that.price = that.topData.price;
            }
          }
          that.bottomStockList = [];
          stockList.forEach((item) => {
            that.bottomStockList.push(that.getStockObject(item));
          });
        },
      });
    },
    getCurrentTotal(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return ((marketData.price * share.number)).toFixed(2);
    },
    getFloatingFullProfit(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return (marketData.price * share.number - share.costtotal).toFixed(2);
      // return parseFloat((this.getFloatingProfit(share) * share.number)-share.costtotal).toFixed(
      //   2
      // );
    },
    getFloatingProfit(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return marketData.price - share.price;
    },
    getFloatingProfitPercentage(share) {
      return parseFloat(
        (this.getFloatingProfit(share) / share.price) * 100
      ).toFixed(2);
    },
    getStockObject(stock) {
      let elements = eval("v_" + stock).split("~");
      let item = {};

      item.name = elements[1]; // 股票名称
      item.code = elements[2]; // 不带字幕的股票代码，603045
      item.short = stock;
      item.price = elements[3]; // 当前价格
      item.yesterdayClosePrice = elements[4]; // 昨收
      item.todayOpenPrice = elements[5]; // 今开

      item.buy1Price = elements[9]; // 买1价格
      item.buy1Num = elements[10]; // 买1数量（手）
      item.buy2Price = elements[11]; // 买2价格
      item.buy2Num = elements[12]; // 买2数量（手）
      item.buy3Price = elements[13]; // 买3价格
      item.buy3Num = elements[14]; // 买3数量（手）
      item.buy4Price = elements[15]; // 买4价格
      item.buy4Num = elements[16]; // 买4数量（手）
      item.buy5Price = elements[17]; // 买5价格
      item.buy5Num = elements[18]; // 买5数量（手）

      item.sell1Price = elements[19]; // 卖1价格
      item.sell1Num = elements[20]; // 卖1数量（手）
      item.sell2Price = elements[21]; // 卖2价格
      item.sell2Num = elements[22]; // 卖2数量（手）
      item.sell3Price = elements[23]; // 卖3价格
      item.sell3Num = elements[24]; // 卖3数量（手）
      item.sell4Price = elements[25]; // 卖4价格
      item.sell4Num = elements[26]; // 卖4数量（手）
      item.sell5Price = elements[27]; // 卖5价格
      item.sell5Num = elements[28]; // 卖5数量（手）

      item.increase = elements[31]; // 涨、跌额
      item.increasePercent = elements[32]; // 涨、跌幅
      item.maxPrice = elements[33]; // 最高价
      item.minPrice = elements[34]; // 最低价

      item.num = elements[36]; // 成交量(手)
      item.totalAccount = elements[37]; // 成交额(万)
      item.turnoverRate = elements[38]; // 换手率
      item.priceToEarnings = elements[39]; // 市盈率

      item.swing = elements[43]; // 振幅
      item.stockMarketsFell = elements[44]; // 流通市值(亿)
      item.aggregatealueListedStock = elements[45]; // 总市值(亿)
      item.price2BookRatio = elements[46]; // 市净率
      item.hardenPrice = elements[47]; // 涨停价
      item.dropPrice = elements[48]; // 跌停价
      item.volumeRatio = elements[49]; // 量比
      item.appointment = elements[50]; // 尾差
      item.average = elements[51]; // 均价

      return item;
    },
    onAccountSelect(item) {
      this.selectedAccount = this.capitalAccountList[item.value];
      this.$store.commit("setSelectedCid", this.selectedAccount.cid);
      this.showPicker = false;
      this.active = "depot";
      this.getDepotStock();
    },
    buySellOperation() {
      let that = this;

      if (that.search === "") {
        Dialog.alert({
          message: "请输入交易股票代码",
        }).then(() => {
          // on close
        });
        return;
      }
      if (that.price === "") {
        Dialog.alert({
          message: "请输入股票交易价格",
        }).then(() => {
          // on close
        });
        return;
      }

      if (parseInt(that.quantity) == 0) {
        Dialog.alert({
          message: "请输入股票交易数量",
        }).then(() => {
          // on close
        });
        return;
      }

      let message =
        this.buySellTab === "buy"
          ? "您是否确定买入该股票?"
          : "您是否确认卖出该股票?";

      Dialog.confirm({
        title: "确认交易",
        message: message,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          that.buySellApi();
        })
        .catch(() => {});
    },
    buySellApi() {
      let that = this;
      var nozzle = this.buySellTab === "buy" ? "buy_stock" : "sell_stock";
      var cid = this.selectedAccount.cid;
      var code = this.selectedShare;
      var number = this.quantity;
      var price =
        this.priceButtonLabel === this.marketPriceLabel
          ? this.topData.price
          : this.price;
      var mold = this.priceButtonLabel === this.marketPriceLabel ? 2 : 1;

      // Toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();

      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: nozzle,
          token: sessionStorage.getItem("token"),
          cid: cid,
          code: code.substring(2),
          price: price,
          number: number,
          mold: mold,
        },
      })
        .then(function (res) {
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            Toast.success(res.data.msg);
            // that.active = "depot";
            that.onTabClick();
          } else if (res.data.code == 2) {
            that.getTradeChannel();
          } else if (res.data.code == 0) {
            Toast.fail(res.data.msg);
          }
        })
        .catch(function () {
          Toast.fail();
        });
    },

    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      // Toast.loading();
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // Toast.clear();
            // that.$toast.fail(res.data.msg);
            that.$refs.commonLoader.hideCommonLoadigIcon();
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onDepotItem(item) {
      this.selectedShare = item.short;
      this.search = this.selectedShare.slice(2);
      this.sellableQty = item.sellable;
      this.loadMarketData(true);
      this.quantity = 0;
    },
  },
  mounted: function () {
    this.priceButtonLabel = this.marketPriceLabel;
    this.selectedShare = this.$store.state.searchSelectedShare; //this.$route.params.code? this.$route.params.code: this.$store.state.searchSelectedShare;
    this.buySellTab = this.$route.params.mode ? this.$route.params.mode : "buy";
    this.price =
      this.buySellTab === "buy"
        ? this.marketPriceBuyLabel
        : this.marketPriceSellLabel;
    if (this.selectedShare) {
      this.search = this.selectedShare.slice(2);
    }

    this.getCapitalAccounts();
    this.loadMarketData();
    this.timerRef = setInterval(() => {
      this.loadMarketData();
      this.onTabClick();
    }, this.timmerFrequncy);
  },
  destroyed: function () {
    clearInterval(this.timerRef);
  },
};
</script>

<style scoped>
.mainSection {
  padding: 0px 10px;
  background: #272a31;
  padding-bottom: 15px;
}
.btnBorder {
  text-align: center;
  height: 26px;
  line-height: 26px;
  margin-top: 5px;
  border: 1px solid #3889fa;
  border-radius: 4px;
}

.btnText {
  color: #ffffff;
  font-size: 14px;
}

#capitalAccountStyle {
  text-align: right;
  color: #ffffff;
}
.capital {
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #ffffff;
  font-size: 14px;
}

.text_style {
  font-size: 13px;
  font-weight: bold;
}

.capital p {
  margin: 0;
  font-size: 13px;
  /* font-weight: bold; */
}

.activeBtn {
  background: #3889fa;
}

.shareDesign {
  text-align: center;
  padding-top: 10px;
  line-height: 25px;
  background: #000000;
  margin-left: -10px;
  margin-right: -10px;
}

.shareName {
  margin-left: 10px;
  color: #ffffff;
  font-size: 14px;
}

.shareCode {
  color: #ffffff;
}

.increasePrecent {
  margin-right: 10px;
}

.minusSignCol {
  border: 1px solid #3889fa;
  line-height: 20px;
  height: 32px;
  border-right: 0;
  background: #000000;
  text-align: center;
}

.minusSign {
  background-color: #000000;
  border: none;
  height: 25px;
  color: #ffffff;
  padding: unset;
}

.limitValue {
  border: 1px solid #3889fa;
  line-height: 20px;
  height: 32px;
  text-align: center;
  border-right: 0;
}

.plusSignCol {
  border: 1px solid #3889fa;
  line-height: 20px;
  height: 32px;
  background: #000000;
  text-align: center;
}
.plusSign {
  background-color: #000000;
  border: none;
  height: 25px;
  color: #ffffff;
  padding: unset;
}

.lossAmt {
  border: 1px solid #3889fa;
  padding: 1px 4px;
  border-radius: 8px;
  color: #ffffff;
  font-size: 13px;
  width: max-content;
}

.warehouse {
  width: 100%;
  background: #757070;
  border: #757070;
  height: 26px;
}

.redText {
  color: #ff2c27;
}
.greenText {
  color: #8bc34a;
}

.dealPopupRow td {
  padding: 5px;
}

.dealPopupRow td span {
  font-size: 13px;
}

.tradingQtyStyle {
  background-color: #3889fa;
}
</style>

<style>
#detailTable .van-tabs__wrap {
  height: 30px !important;
}

#detailTable .van-tab {
  background: #dcdee0;
  color: #3889fa;
}

#detailTable .van-tab--active {
  background: #3889fa !important;
  color: #ffffff;
}

#detailTable .van-tabs__line {
  display: none;
}

#searchStyle .van-field__control {
  color: #ffffff !important;
  text-align: center;
  font-size: 14px;
}

#capitalAccountStyle .van-field__control {
  color: #ffffff !important;
  text-align: right;
  font-size: 14px;
}

#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Trading.vue